module.exports = __webpack_public_path__ + "img/icon_historial_hover.354b1132.svg";